/* eslint-disable */
import { TrashIcon } from '@heroicons/react/20/solid'
import axios, { AxiosError, AxiosResponse } from 'axios'
import classNames from 'classnames'
import {
    Dispatch,
    SetStateAction,
    useContext,
    useEffect,
    useState,
} from 'react'
import { toast } from 'react-toastify'
import { getPlanPremiums, getPlans } from '../../../api/plansapi'
import { postPolicyQuote } from '../../../api/policyquote'
import config from '../../../config'
import childPlanFormDataContext, {
    IChildPlanFormData,
} from '../../../contexts/ChildPlanFormDataContext'
import ParentFormDataContext, {
    IParentFormData,
} from '../../../contexts/ParentFormDataContext'
import returnCustomerFormDataContext from '../../../contexts/ReturnCustomerFormDataContext'
import { ICodeDescription } from '../../../model/ICodeDescription'
import { IPlan } from '../../../model/IPlan'
import { IPolicyQuoteRequest } from '../../../model/IPolicyQuoteRequest'
import { fetchPolicyQuote } from '../../../utils/fetchPolicyQuote'
import Button from '../../button/Button'
import {
    IButtonSelectItem,
} from '../../buttonSelect/ButtonSelect'
import ChildInfo from './ChildInfo'

export interface IChildSection {
    className?: string
}
// Functionalities: 1. catch all the error messages which res status equals to 400; 
// 2. the same error message will only be saved once
export async function fetchPolicyQuoteErrorMessages(
    parentData: IParentFormData,
    childData: IChildPlanFormData[],
    setParentFormData: Dispatch<SetStateAction<IParentFormData>>,
) {
    let insureds: any = []
    childData.map((child: IChildPlanFormData, index) => {
        if (child.Plan.PlanCode != "") {
            let childInfo = {
                planCode: child.Plan.PlanCode,
                organizationSchoolId: child.School.id ? child.School.id : -1,
                dob: child.Dob ? child.Dob : new Date(2022, 1, 1),
                firstname: index.toString(),
            }
            insureds.push(childInfo)
        }
    })
    const quoteRequest: IPolicyQuoteRequest = {
        provstate: parentData?.Province?.id ? parentData?.Province?.id : 'ON',
        language: parentData?.Language,
        emailAddress: parentData.Email ? parentData.Email : '',
        effectivedate: parentData.StartDate ? parentData.StartDate : new Date(),
        insureds: insureds,
    }
    try {
        if (insureds.length > 0) {
            await postPolicyQuote(quoteRequest)
        }
    } catch (error: any | AxiosError) {
        if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError
            const axiosRespone = axiosError.response as AxiosResponse

            setParentFormData((prevFormData) => {
                if (!prevFormData.QuoteErrorMessages.includes(axiosRespone.data.error.message)) {
                    const newFormData = {
                        ...prevFormData,
                        QuoteErrorMessages: [...prevFormData.QuoteErrorMessages, axiosRespone.data.error.message]
                    }
                    return newFormData
                }
                else {
                    const newFormData = {
                        ...prevFormData,
                        QuoteErrorMessages: [...prevFormData.QuoteErrorMessages]
                    }
                    return newFormData
                }
            })
        }
    }
}

const ChildSection: React.FC<IChildSection> = ({
    className,
}) => {
    const { parentFormData, setParentFormData } = useContext(
        ParentFormDataContext
    )

    const { childPlanFormData, setChildPlanFormData } = useContext(
        childPlanFormDataContext
    )

    const { returnCustomerFormData, setReturnCustomerFormData } = useContext(
        returnCustomerFormDataContext
    )

    const [isLoading, setIsLoading] = useState<boolean>(false) //used for making a component responsive with a spinner (for the future)
    const maxDate = new Date()
    const policyMaxDate = Number(config.REACT_APP_MAXPOLICY)
    maxDate.setFullYear(maxDate.getFullYear() + policyMaxDate)

    const [plans, setPlans] = useState<IPlan[]>()
    const [premiums, setPremiums] = useState<IPlan[]>()
    const [premiumOptions, setPremiumOptions] = useState<{
        [key: string]: number
    }>({})

    const [planDurations, setPlanDurations] = useState<ICodeDescription[]>([])
    const [planDurationOptions, setPlanDurationOptions] = useState<
        IButtonSelectItem[]
    >([])

    const [plansLoading, setPlansLoading] = useState<boolean>(false)
    const [premiumsLoading, setPremiumsLoading] = useState<boolean>(false)
    const [planDurationsLoading, setPlanDurationsLoading] =
        useState<boolean>(false)

    useEffect(() => {
        if (parentFormData?.Province?.id) {
            getPremiums(parentFormData.Language, parentFormData.Province.id)
        }
    }, [parentFormData?.Province?.id])

    useEffect(() => {
        if (parentFormData.PlanDuration.DurationText !== "") {
            fetchPolicyQuote(
                parentFormData,
                childPlanFormData,
                setParentFormData,
                setChildPlanFormData
            )
        }
    }, [parentFormData.PlanDuration.Duration, premiums])

    useEffect(() => {
        getPlanList(parentFormData.Language)
    }, [parentFormData.Language])

    useEffect(() => {
        setPremiumOptions({})
        let temp: any = {}
        premiums?.map((prem: IPlan) => {
            temp[prem.plancode] = prem.premium
        })
        setPremiumOptions(temp)
    }, [premiums])

    async function getPlanList(language: number) {
        setPlansLoading(true)
        try {
            const plans = await getPlans(language)
            setPlans(plans)
        } catch (error) {
            toast.error('Error - Could not load Plans')
        } finally {
            setPlansLoading(false)
        }
    }

    async function getPremiums(language: number, province: string) {
        setPremiumsLoading(true)
        try {
            const premiums = await getPlanPremiums(language, province)
            setPremiums(premiums)
        } catch (error) {
            toast.error('Error - Could not load Premiums')
        } finally {
            setPremiumsLoading(false)
        }
    }

    return (
        <div className={classNames(className, " space-y-[2rem]")}>
            {childPlanFormData &&
                childPlanFormData.map((childData, index) => (
                    <div key={index} className="flex justify-center">
                        <div className='bg-white lg:w-[55rem] md:w-[31rem] w-[20rem] shadow-md py-6 flex justify-center'>
                            {plans && (
                                <div className='lg:w-[42rem] w-[18rem] relative pb-5'>
                                    <ChildInfo
                                        childIndex={index}
                                        plans={plans}
                                        premiumOptions={premiumOptions}
                                        plansLoading={plansLoading}
                                        premiumsLoading={premiumsLoading}
                                    ></ChildInfo>
                                    {childPlanFormData.length > 1 && (
                                        <div className="pt-4 text-end">
                                            <Button
                                                text="removeChild"
                                                textColor='text-black'
                                                postfix={
                                                    <TrashIcon className="z-6 h-6  fill-black" />
                                                }
                                                handleClick={() => {
                                                    const newChildPlanFormData = [
                                                        ...childPlanFormData,
                                                    ]
                                                    newChildPlanFormData.splice(
                                                        index,
                                                        1
                                                    )
                                                    setChildPlanFormData(
                                                        newChildPlanFormData
                                                    )
                                                    fetchPolicyQuote(
                                                        parentFormData,
                                                        newChildPlanFormData,
                                                        setParentFormData,
                                                        setChildPlanFormData
                                                    )
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                ))}
        </div>
    )
}

export default ChildSection

